<template>
  <div class="main-layout">
    <Navbar :newSearchButtonActive="newSearchButtonVisible" @newSearch="onNewSearchClicked" />
    <router-view />
  </div>
</template>

<script>

import Navbar from "@/components/Navbar.vue"

export default {
  name: "Main",
  components : {
      Navbar
  },
  data: function () {
    return {
      newSearchButtonVisible: true
    }
  },
  methods: {
    onNewSearchClicked () {
      this.$router.push({
        name: "new-search-query"
      });
    }
  },
  watch:{
    $route (to) {
      // Show the new search button everywhere except on the
      // new search page
      this.newSearchButtonVisible = to.name != "new-search-query";
    }
  }
};

</script>

<style>
</style>